import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter} from 'react-router-dom';

import {createStore, applyMiddleware, compose, combineReducers} from 'redux'; //import combineReducers if you have more than one reducer, see index.js in burgerbuilder
import {Provider} from 'react-redux';

import authReducer from './store/reducers/auth';
import regReducer from './store/reducers/reg';
import fetchReducer from './store/reducers/fetch';
import hideReducer from './store/reducers/hide';
import searchReducer from './store/reducers/search';

import thunk from 'redux-thunk';

const rootReducer=combineReducers({
    
    auth: authReducer,
    reg: regReducer,
    fetch: fetchReducer,
    hide: hideReducer,
    search: searchReducer
    
})

const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

//const store=createStore(authReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

const store= createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(<Provider store={store}><BrowserRouter><App /></BrowserRouter></Provider>, document.getElementById('root'));
registerServiceWorker();


//Firebase API-key:AIzaSyAZey6bg2e4XKRJxrV8UWtir7_Uds3vVSY

//Firebase URL: https://vrc-hof.firebaseio.com/

//Sign up
//https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyAZey6bg2e4XKRJxrV8UWtir7_Uds3vVSY

//Sign in
//https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyAZey6bg2e4XKRJxrV8UWtir7_Uds3vVSY


// WEBPACK FOOTER //
// ./src/index.js